define('models/resetPasswordModel',[
    'models/base/baseModel',
    'helpers/skydropContextHelper',
],
function (BaseModel, contextHelper) {
    'use strict';
    return BaseModel.extend({
        url: function () {
            return contextHelper.getResetPasswordUrl();
        },
        
        defaults: {},
        
        parse: function (response) {
            return response.length > 0 ? response[0] : response;
        }
    });
});
